import React, { useMemo } from 'react';
import Table from '../../../../components/tables/Table';

const COLUMNS = [
  { label: 'Date', field: 'date', sortable: true, type: 'date' },
  { label: 'Started', field: 'started', sortable: true, type: 'string' },
  { label: 'Finished', field: 'finished', sortable: true, type: 'string' },
  { label: 'Files Exported', field: 'filesExported', sortable: true, type: 'number' },
  { label: 'Export Pending. Awaiting Meterdata / Infill', field: 'exportPendingAwaiting', sortable: true, type: 'number' },
  { label: 'Errors', field: 'errors', sortable: true, type: 'string' },
];

export default function ExportFileTable({ rows = [], refreshing = false }) {
  const columns = useMemo(() => COLUMNS, []);

  return (
    <Table
      rows={Array.isArray(rows) ? rows : []}
      columns={columns}
      stickyHeader
      zebra
      bordered
      hover

      defaultSort={{ field: 'date', direction: 'desc' }}
    />
  );
}
